<bv-dialog-title>
  @if (editing) {
    <span>{{ clubServ.locationLabel(existing) || ("LOCATION" | translate) }}</span>
  } @else {
    <span>{{ "NEW_LOCATION" | translate }}</span>
  }
</bv-dialog-title>
<bv-dialog-body>
  <form class="club-location__form" (ngSubmit)="save()">
    <bv-form-field [label]="'LOCATION_NAME' | translate">
      <input
        bv-input
        type="text"
        [(ngModel)]="name"
        name="name"
        [disabled]="!clubServ.canConfigLocations"
        autocomplete="organization"
        />
    </bv-form-field>
    <bv-form-field [label]="'STREET_ADDRESS' | translate">
      <input
        bv-input
        type="text"
        [(ngModel)]="street"
        name="street"
        [disabled]="!clubServ.canConfigLocations"
        autocomplete="street-address"
        />
    </bv-form-field>
    <div class="club-location__row">
      <bv-form-field [label]="'POSTAL_CODE' | translate" class="club-location__col club-location__col--postal">
        <input
          bv-input
          type="text"
          [(ngModel)]="postalCode"
          name="postalCode"
          [disabled]="!clubServ.canConfigLocations"
          autocomplete="postal-code"
          />
      </bv-form-field>
      <bv-form-field [label]="'CITY' | translate" class="club-location__col">
        <input
          bv-input
          type="text"
          [(ngModel)]="city"
          name="city"
          [disabled]="!clubServ.canConfigLocations"
          autocomplete="address-level2"
          />
      </bv-form-field>
      @if (isUS) {
        <bv-form-field [label]="'STATE' | translate" class="club-location__col club-location__col--state">
          <input
            bv-input
            type="text"
            [(ngModel)]="state"
            name="state"
            [disabled]="!clubServ.canConfigLocations"
            autocomplete="address-level1"
            />
        </bv-form-field>
      }
      <bv-form-field [label]="'COUNTRY' | translate" class="club-location__col">
        <input
          bv-input
          type="text"
          [(ngModel)]="country"
          name="country"
          [disabled]="!clubServ.canConfigLocations"
          autocomplete="country-name"
          />
      </bv-form-field>
    </div>
    <bv-form-field [label]="'TELEPHONE' | translate">
      <input
        bv-input
        type="tel"
        [(ngModel)]="telephone"
        name="telephone"
        [disabled]="!clubServ.canConfigLocations"
        autocomplete="tel"
        />
    </bv-form-field>
    <bv-form-field
      [label]="'MAP_LINK' | translate"
      [hint]="'MAP_LINK_HINT' | translate"
      >
      <input
        bv-input
        type="url"
        inputmode="url"
        [(ngModel)]="mapURL"
        name="mapURL"
        [disabled]="!clubServ.canConfigLocations"
        autocomplete="off"
        placeholder="https://"
        />
    </bv-form-field>
    @if (mapsSearchURL) {
      <a
        class="club-location__maps-helper"
        [href]="mapsSearchURL"
        target="_blank"
        rel="noopener noreferrer"
        >
        <bv-icon name="map" size="sm"></bv-icon>
        <span>{{ "SEARCH_ADDRESS_ON_MAPS" | translate }}</span>
      </a>
    }
    <bv-checkbox
      [(ngModel)]="setHome"
      name="setHome"
      [disabled]="!clubServ.canConfigLocations"
      >{{ "SET_AS_HOME_LOCATION" | translate }}</bv-checkbox>
  </form>
</bv-dialog-body>
<bv-dialog-footer>
  @if (clubServ.canConfigLocations) {
    <button
      id="btn_location_confirm"
      bv-button variant="primary"
      [disabled]="isBlank || saving"
      (click)="save()"
      >
      {{ "CONFIRM" | translate }}
    </button>
    @if (editing) {
      <button
        id="btn_location_delete"
        bv-button variant="ghost" class="tc-error"
        (click)="delete()"
        >
        {{ "DELETE_LOCATION" | translate }}
      </button>
    }
  }
  <span class="flex-1"></span>
  <app-close-dialog-button
    label="{{ 'CANCEL' | translate }}"
  ></app-close-dialog-button>
</bv-dialog-footer>
